import { Component, Fragment, SyntheticEvent } from 'react';
import { IconName } from '@optimus-web/icons';
import { Spinner } from '../Spinner';
import { ImageProps } from './ImageProps';
import { ImageElement, ImagePlaceholder, ImagePlaceholderIcon, ImageWrapper, SpinnerWrapper } from './style';

export interface ImageState {
    isLoaded: boolean;
}

export default class Image extends Component<ImageProps, ImageState> {
    private placeholderTimeoutId: number | null = null;

    static defaultProps = {
        sizes: '100vw',
        loaderDelay: 0,
    };

    readonly state: ImageState = {
        isLoaded: false,
    };

    componentDidUpdate({ src: prevSrc }: ImageProps) {
        const { shouldShowLoader, loaderDelay, src } = this.props;

        if (shouldShowLoader && prevSrc !== src) {
            this.placeholderTimeoutId = window.setTimeout(() => this.setState({ isLoaded: false }), loaderDelay);
        }
    }

    componentWillUnmount() {
        this.clearPlaceholderTimeoutIfExists();
    }

    clearPlaceholderTimeoutIfExists = () => {
        if (this.placeholderTimeoutId !== null) {
            window.clearTimeout(this.placeholderTimeoutId);
            this.placeholderTimeoutId = null;
        }
    };

    handleLoad = (event: SyntheticEvent<HTMLElement>) => {
        const { onLoad } = this.props;

        if (onLoad) {
            onLoad(event);
        }

        this.clearPlaceholderTimeoutIfExists();
        this.setState({ isLoaded: true });
    };

    render() {
        const {
            shouldShowLoader,
            loaderDelay,
            src,
            forwardedRef,
            rounded,
            placeholderProps = {},
            alt = '',
            imageRatio,
            ...other
        } = this.props;
        const { isLoaded } = this.state;

        const isRatioDefined = !!imageRatio;

        const imageElementProps = {
            ...other,
            src,
            isLoaded,
            shouldShowLoader,
            onLoad: this.handleLoad,
            rounded,
            alt,
            isRatioDefined,
        };

        const imagePlaceholderProps = {
            ...placeholderProps,
            ref: forwardedRef,
            rounded,
            isRatioDefined,
        };

        const Wrapper = imageRatio ? ImageWrapper : Fragment;
        const wrapperProps = imageRatio ? { imageRatio } : {};

        return (
            <Wrapper {...wrapperProps}>
                {src ? (
                    <ImageElement {...imageElementProps} />
                ) : (
                    <ImagePlaceholder {...imagePlaceholderProps}>
                        <ImagePlaceholderIcon
                            iconSize={placeholderProps.iconSize}
                            value={placeholderProps.iconName || IconName.Camera}
                        />
                    </ImagePlaceholder>
                )}
                {shouldShowLoader && !isLoaded ? (
                    <SpinnerWrapper isRatioDefined={isRatioDefined}>
                        <Spinner />
                    </SpinnerWrapper>
                ) : null}
            </Wrapper>
        );
    }
}
